import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import pick from 'lodash/pick';
import React from 'react';

import { EditLabResultFormV2 } from 'src/labs/EditLabResultFormV2';
import { PatientSubmittedTestResult } from 'src/labs/types';
import Colors from 'src/nightingale/Colors';

export const LabResultDialogV2: React.FC<{
  isOpen: boolean;
  labResult: PatientSubmittedTestResult | null;
  onSaveAsDraft: (values: Partial<PatientSubmittedTestResult['result']>) => Promise<void>;
  onSignAndResult: (values: Partial<PatientSubmittedTestResult['result']>) => Promise<void>;
  setCurrentResult: React.Dispatch<React.SetStateAction<PatientSubmittedTestResult | null>>;
}> = ({ isOpen, labResult, onSaveAsDraft, onSignAndResult, setCurrentResult }) => {
  const styles = useStyles();

  if (!labResult) {
    return null;
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={isOpen} onClose={() => setCurrentResult(null)}>
      <DialogTitle classes={{ root: styles.title }}>Edit Result</DialogTitle>
      <DialogContent>
        <EditLabResultFormV2
          images={labResult.images}
          onSaveAsDraft={values => onSaveAsDraft(values)}
          onSignAndResult={values => onSignAndResult(values)}
          item={pick(labResult.result, [
            'bupPositive',
            'notes',
            'signedAt',
            'signedBy',
            'status',
            'verified',
            'invalidReason',
          ])}
          onCancel={() => setCurrentResult(null)}
        />
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles({
  title: {
    '& .MuiTypography-root': {
      color: Colors.Gray5,
      fontFamily: 'Tenor Sans',
      fontSize: 24,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.45,
      letterSpacing: 0.2,
    },
  },
});
